import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

export default (Com: Function, action: Function) => {
  const FormComponent = (props) => {
    const [loading, setLoading] = useState(false);
    const [unmounted, setUnmounted] = useState(false);

    useEffect(() => {
      return () => {
        setUnmounted(true);
      };
    }, []);

    const handleSubmitClick = (submitData: {}, callback: Function) => {
      setLoading(true);
      props.action(submitData, status => {
        if (!unmounted) {
          setLoading(false);
        }

        callback && callback(status);
      });
    };

    return <Com onSubmit={handleSubmitClick} loading={loading} {...props} />;
  };

  return connect(null, { action })(FormComponent);
};



// WEBPACK FOOTER //
// ./src/HOCs/submitFormData.tsx